import { XCloseGray } from "../icons/XClose";
import { Row } from "./Row";
import { TextComponent } from './TextComponent';
interface LabelProps {
    title: string;
    className?: string;
    variant?: string;
    color?: "white" | "primary";
    onClick?: (title: string) => void;
}
export const Label = ({ title, variant, className, onClick, color = "primary" }: LabelProps) => {
    return (
        <Row
            mainAxisAlignment="center"
            crossAxisAlignment="center"
            className={`${variant === "circle" ? `rounded-full border-[1px] py-1 ${color === "primary" ? "border-primary" : "border-grayLight2"}` : "rounded-md w-fit py-2 hover:bg-pink hover:text-white"}  gap-1.5 px-3  items-center ${color === "primary" ? "text-primary bg-socondary" : "text-graySecondary bg-grayDefault"} ${className}`}
            flexible
        >
            <TextComponent variant="nh6" className="select-none break-all">
                {title}
            </TextComponent>
            {variant !== "circle" &&
                <button
                    type="button"
                    aria-label="Delete or Close"
                    onClick={() => onClick?.(title)}
                >
                    <XCloseGray size={15} />
                </button>
            }
        </Row>
    )
}
